import { render, staticRenderFns } from "./HooksExportMenu.vue?vue&type=template&id=2ee9c238&scoped=true"
import script from "./HooksExportMenu.vue?vue&type=script&lang=js"
export * from "./HooksExportMenu.vue?vue&type=script&lang=js"
import style0 from "./HooksExportMenu.vue?vue&type=style&index=0&id=2ee9c238&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ee9c238",
  null
  
)

export default component.exports